import { parseMappingBasis } from './mappingReview';
/** Read-only consumer contract. An occupational group never selects a role or a rate. */ export function rosettaConsumerContext(entry, mapping) {
    const basis = parseMappingBasis(mapping.reviewedBasisJson);
    const current = mapping.status === 'APPROVED' && mapping.fromEntryId === entry.id && (!mapping.currentFromEntryId || mapping.currentFromEntryId === entry.id) && !entry.supersededById && entry.status !== 'RETIRED' && basis?.source?.id === entry.id && basis.source.version === entry.version && basis.anchor?.id === mapping.toAnchorId;
    return {
        entryId: entry.id,
        version: entry.version,
        mappingId: mapping.id,
        anchorId: mapping.toAnchorId,
        current,
        scope: entry.contractVehicleName ? `Vehicle context: ${entry.contractVehicleName}. Confirm contractual eligibility before use.` : 'No vehicle eligibility is established by this mapping.',
        constraints: [
            entry.qualifications && `Qualifications: ${entry.qualifications}`,
            entry.clearance && `Clearance: ${entry.clearance}`,
            entry.certifications && `Certifications: ${entry.certifications}`,
            'The consuming workspace owns its selected role, contractual assessment, staffing assignment and pricing assumption. Mapping changes require deliberate review; selected roles and rates remain unchanged.'
        ].filter(Boolean)
    };
}
/** No return URL or consumer-controlled scope is sent to the data gateway. */ export function rosettaCompareHref(anchorId, entryId) {
    return `/registries?${new URLSearchParams({
        tab: 'lcats',
        view: 'compare',
        anchor: anchorId,
        entry: entryId
    }).toString()}`;
}
